<template>
  <div class="item" :class="{ failed: error }">
    <label v-if="label" :for="id" class="form-control-label">
      {{ label }}
      <span v-if="required">*</span>
    </label>
    <input
      :id="id"
      :type="type"
      :placeholder="`${placeholder}${!label && required ? '*' : ''}`"
      v-bind="$attrs"
      class="form-control"
      :class="{ failed: error }"
      v-model="vModel"
      ref="inputEl"
    />
  </div>
</template>
<script>
import { computed, ref } from "vue";

export default {
  name: "TextField",
  props: {
    id: {
      type: [String, Number],
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    rules: {
      type: Array,
      default: () => {
        return [];
      }
    },
    error: {
      type: Boolean,
      default: false
    },
    modelValue: String,
    maxLength: {
      type: Number,
      deafult: null
    }
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const required = computed(() => {
      return props.rules.includes("required");
    });

    //console.log(props.limit);

    const inputEl = ref();
    const vModel = computed({
      get() {
        return props.modelValue;
      },
      set(newValue) {
        let finalValue = newValue;
        if (props.maxLength) {
          finalValue = String(newValue).substring(0, props.maxLength);
        }
        if (inputEl.value) {
          inputEl.value.value = finalValue;
        }
        emit("update:modelValue", finalValue);
      }
    });

    return {
      inputEl,
      required,
      vModel
    };
  }
};
</script>
